export class AdvancedSearchAll
{
  Id:number;
  airportIdentifier: string;
  faaSite: string;
  region: string;
  airportName: string;
  associatedCity: string;
  far139Ndx: string;
  part139: string;
  stateCode: string;
  ownership: string;
  airportUse: string;
  based: string;
  operationsTotal: string;
  runwayLength: string;
  runwayWidth: string;
  surfaceTypeCondition: string;
  rwyIdentifier: string;
  fuel: string;
  serviceLevelName: string;
  serviceLevelAbbr: string;
  npiasHubType: string;
  ado: string;
  arptLat: string;
  arptLong: string;
  owner: string;
  ownerAddress: string;
  ownerAddressCsz: string;
  ownerPhone: string;
  manager: string;
  managerAddress: string;
  managerAddressCsz: string;
  managerPhone: string;
  otherServices: string;
  unicom: string;
  surfaceTreatment: string;
  baseRwyMarkingType: string;
  recpRwyMarkingType: string;
  baseRwyMarkingCondition: string;
  recpRwyMarkingCondition: string;
  baseFar77Category: string;
  recpFar77Category: string;
  baseCloseInObstruction: string;
  recpCloseInObstruction: string;
  surfaceTreatmentDesc: string;
  baseRwyMarkingTypeDesc: string;
  recpRwyMarkingTypeDesc: string;
  baseFar77CategoryDesc: string;
  recpFar77CategoryDesc: string;
  surfaceTypeHard: string;
  ctrlTwr: string;
  ownerInfo:string;
  managerInfo:string;
  nonNpias:string;
  commercialService:string;

  primary:string;
  reliever:string;
  generalAvaition:string;
  national:string;
  regional:string;
  local:string;
  basic:string;
  unclassified:string;
  aBasedMf: string;
  aOperationsMf: string;

  aRunwayLengthMf: string;
  aRunwayWidthMf: string;

  aSurfaceCondition: string;
  aPhysicalElevOperator:string;

  baseRunwayElevation:string;

  arptElev:string;



}
